import React from "react";
import { BuyBulkTicketService } from "../../types";
import { PurchaseOrderDetails } from "shared/components/purchaseOrder";
import PaymentComponentWrapper from "shared/components/paymentWrapper";
import { useRegDetail } from "shared/context/regDetail";
import { getStripeReturnUrlForMyExp, isPaymentReceiptPendingForPO } from "apps/myExperience/utils";

export default function BulkTicketPayment(props: { service: BuyBulkTicketService; ticketFormName: string }) {
  const { showCardIcons, invoicePaymentEnabled } = useRegDetail();

  const canEditQuantity = React.useMemo(() => {
    return !isPaymentReceiptPendingForPO(props.service.state.purchaseOrder);
  }, [props.service.state.purchaseOrder]);

  const backClickHandler = React.useCallback(() => {
    props.service.dispatcher.updateStep(1);
  }, [props.service.dispatcher]);

  return (
    <div className="bulkTicketPayment">
      {props.service.state.purchaseOrder && (
        <PurchaseOrderDetails
          originatingFormName={props.ticketFormName}
          purchaseOrder={props.service.state.purchaseOrder}
          editClickHandler={canEditQuantity ? backClickHandler : undefined}
        />
      )}
      {props.service.state.purchaseOrder && props.service.registrationParticipantId && (
        <PaymentComponentWrapper
          amount={props.service.state.purchaseOrder.amount}
          registrationParticipantId={props.service.registrationParticipantId}
          purchaseOrderId={props.service.state.purchaseOrder.purchaseOrderId}
          successHandler={props.service.paymentSuccessHandler}
          errorHandler={props.service.paymentErrorHandler}
          showCardIcons={showCardIcons}
          onAmountMismatch={props.service.paymentMismatchHandler}
          invoicePaymentEnabled={invoicePaymentEnabled}
          invoicePaymentConfig={{
            initialEmail: props.service.state.purchaseOrder.invoicePaymentRequest?.invoicePayerEmail
          }}
          invoicePayerId={props.service.state.purchaseOrder.invoicePaymentRequest?.invoicePayerId}
          invoicePaymentRequestId={props.service.state.purchaseOrder.invoicePaymentRequest?.invoicePaymentRequestId}
          invoicePayerPaymentRequestSuccessHandler={props.service.invoicePayerPaymentRequestSuccessHandler}
          resendInvoicePaymentReminderSuccessHandler={props.service.resendInvoicePaymentReminderSuccessHandler}
          stripeReturnUrl={getStripeReturnUrlForMyExp({
            registrationParticipantId: props.service.registrationParticipantId,
            purchaseOrderId: props.service.state.purchaseOrder.purchaseOrderId
          })}
          offlinePaymentConfig={{
            offlinePaymentRequested: props.service.state.purchaseOrder.hasRequestedOfflinePayment,
            paymentReferenceId: props.service.state.purchaseOrder.transaction?.providerPaymentId
          }}
          offlineTransactionUpdateSuccessHandler={props.service.offlineTransactionUpdateSuccessHandler}
          offlineTransactionCancelSuccessHandler={props.service.offlineTransactionCancelSuccessHandler}
        />
      )}
    </div>
  );
}
